import Row from '@components/Row';
import Text from '@components/Text';
import TextUnderline from '@components/TextUnderline';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import MapPin from '@icons/MapPin';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';

/** 주문 매장명 */
function OrderShopInfo() {
    const { shopName } = useCalculatedRequest();
    return (
        <Container spacing={1} fullWidth>
            <MapPin size={16} color='var(--color-icon-default)'/>
            <TextUnderline>
                <Text size='title' fontWeight='bold' color={colors.textPrimary}>{shopName}</Text>
            </TextUnderline>
        </Container>
    );
}

const Container = styled(Row)`
    padding: 0 var(--spacing-4);
`;

export default OrderShopInfo;
